/* eslint-disable react/jsx-no-target-blank */
import classNames from "classnames";
import { Typography, TypographyVariant } from "../Typography/Typography";
import "./Link.scss";

interface LinkProps {
  children: React.ReactNode;
  href: string;
  openInNewTab?: boolean;
  variant?: TypographyVariant;
  className?: string;
}
export const Link = ({
  children,
  href,
  openInNewTab,
  variant = "caption",
  className,
}: LinkProps) => {
  const classes = classNames("Link", className);
  return (
    <Typography tagVariant="span" desktop={variant}>
      <a
        className={classes}
        href={href}
        target={openInNewTab ? "_blank" : undefined}
        rel={openInNewTab ? "noreferrer" : undefined}
      >
        {children}
      </a>
    </Typography>
  );
};
